export default __webpack_public_path__ + "static/media/workfields002.c7588841.jpg";